import * as Sentry from '@sentry/react';
import { Checkbox, colors, Grid, Typography } from '@ui-components/neo.tax';
import * as React from 'react';

import { useUpdateCompanyQuestion } from '@neo.tax/shared';

import { MissingAvailableChoices } from './company-info.errors';
import { QuestionProps } from './company-info.types';

export const CheckboxesField: React.FC<QuestionProps> = ({ question }) => {
  const updateCompanyQuestionAnswer = useUpdateCompanyQuestion(question.id, question.questionId);

  if (!question.questionChoices) {
    Sentry.captureException(new MissingAvailableChoices(question));
    return null;
  }

  const selectedChoiceCodes = question.questionChoices
    .filter((choice) => choice.selected)
    .map((choice) => choice.choiceCode);

  return (
    <Grid cols={2} gap={4}>
      {question.questionChoices?.map((choice) => (
        <Checkbox
          key={choice.id}
          id={choice.id}
          name={choice.choiceCode}
          title={
            <Typography fontSize="sm" fontWeight="medium" color={colors.gray[700]}>
              {choice.displayText}
            </Typography>
          }
          subtitle={
            <Typography fontSize="sm" fontWeight="normal" color={colors.gray[500]}>
              {choice.displaySubtext}
            </Typography>
          }
          checked={choice.selected}
          onChange={(newSelected): void => {
            updateCompanyQuestionAnswer({
              answerValues: newSelected
                ? [...selectedChoiceCodes, choice.choiceCode]
                : selectedChoiceCodes.filter((code) => code !== choice.choiceCode),
            });
          }}
        />
      ))}
    </Grid>
  );
};
